export abstract class BaseModel {
    public id?: string;
    public created?: Date;
    public modified?: Date;
}